import Button from './Button';
import InputText from './Input/InputText';
import { BoardSearch } from '@/components/Css/Board';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC, useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

interface BoardSearchBarProps {
  initialKeyword: string;
  initialCategory: string;
  onSearch: (value: string) => void;
  searchKey: string;
}

interface SearchFormData {
  keyword: string;
  category: string;
}
const FormWrap = styled.div`
  ${breakpoint(`mobile`)} {
    width: 100%;
  }
`;
const FomrContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const NewsBoardSearchBar = styled<FC<BoardSearchBarProps>>(
  ({ initialKeyword, onSearch }) => {
    const { register, handleSubmit, setValue } = useForm<SearchFormData>();

    const onSubmit: SubmitHandler<SearchFormData> = ({ keyword }) => {
      onSearch(keyword);
      return false;
    };

    useEffect(() => {
      // 검색어가 비워질때 함께 동기화 (검색중에 초기페이지로 갈 경우)
      if (!initialKeyword) {
        setValue(`keyword`, ``);
      }
    }, [initialKeyword, setValue]);

    /*
    if (props.searchKey && props.searchKey !== ``) {
      setValue(`keyword`, props.searchKey);
    }
    if (props.searchKey && props.searchKey === ``) {
      setValue(`keyword`, ``);
    }
*/

    return (
      <FomrContainer>
        <FormWrap>
          <form onSubmit={handleSubmit(onSubmit)}>
            <BoardSearch>
              <div className="label-wrap">
                <InputText
                  ref={register}
                  name="keyword"
                  placeholder="검색어를 입력하세요"
                />
                <button type="submit">
                  <span className="a11y">검색</span>
                </button>
              </div>
              <div className="col-btn">
                <Button
                  color="white-grey"
                  outline
                  onClick={() => {
                    setValue(`keyword`, ``);
                    onSearch(``);
                  }}
                >
                  전체보기
                </Button>
              </div>
            </BoardSearch>
          </form>
        </FormWrap>
      </FomrContainer>
    );
  },
)``;

export default NewsBoardSearchBar;
